import * as React from 'react'

import { Button } from '@thg-commerce/gravity-elements'
import { styled, spacing, mq, Text } from '@thg-commerce/enterprise-theme'

interface BrandsPageProps {
  brands: {
    character: string
    brands: {
      name: string
      page?: {
        path?: string
      }
      link?: string
    }[]
  }[]
}

const CharacterContainer = styled.div`
  display: flex;
  overflow: auto;
  margin: ${spacing(3)} auto;

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    justify-content: center;
    flex-wrap: wrap;
  }
`

const CharacterButton = styled(Button)`
  margin-right: ${spacing(1)};

  button,
  button:active,
  button:hover {
    padding: ${spacing(1)} ${spacing(2)};
  }

  button:focus {
    padding: calc(${spacing(1)} - 2px) calc(${spacing(2)} - 2px);
  }

  &:last-child {
    margin-right: 0;
  }
`

const BrandRow = styled.div`
  display: flex;
  flex-direction: column;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    flex-direction: row;
    padding: ${spacing(3)} 0;
    border-bottom: 1px solid
      ${(props) => props.theme.colors.palette.greys.light};
  }
`

const Character = styled.div`
  ${Text('large1', 'alternate')}

  padding: ${spacing(2)} ${spacing(2)};
  background: ${(props) => props.theme.colors.palette.greys.lighter};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    background: none;
    padding: 0 ${spacing(3)};
  }
`

const BrandLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  padding: ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    flex-direction: row;
    padding: 0;
  }
`

const BrandButton = styled(Button)`
  width: 100%;
  justify-content: flex-start;
  text-transform: none;
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: 25%;

    &:hover,
    &:focus {
      width: 25%;
    }
  }
`

export const BrandsPage: React.FunctionComponent<BrandsPageProps> = (props) => {
  const brandRowRefs = React.useRef<{
    [character: string]: HTMLDivElement | null
  }>({})

  const characters = (
    <CharacterContainer>
      {props.brands.map((character) => (
        <CharacterButton
          emphasis="medium"
          key={`character-${character.character}`}
          onClick={() => {
            if (brandRowRefs.current[character.character]) {
              brandRowRefs.current[character.character]!.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }
          }}
        >
          {character.character}
        </CharacterButton>
      ))}
    </CharacterContainer>
  )

  return (
    <div>
      {characters}
      {props.brands.map((character) => (
        <BrandRow
          key={`brands - ${character.character}`}
          ref={(element) =>
            (brandRowRefs.current[character.character] = element)
          }
        >
          <Character>{character.character}</Character>
          <BrandLinks>
            {character.brands.map((brand) => (
              <BrandButton
                emphasis="low"
                href={`${brand.page?.path}.list`}
                renderedAs="a"
                key={`brand - ${brand.name}`}
                style={{}}
              >
                {brand.name}
              </BrandButton>
            ))}
          </BrandLinks>
        </BrandRow>
      ))}
    </div>
  )
}
